module.exports = __webpack_public_path__ + "static/skydive-cd3aad2f477186d45efe5d6da2cf39cd.jpg";